module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"carBrand":"Марка","carNumber":"Держ. номер","carModel":"Модель","dateProduction":"Рік випуску"},"en":{"carBrand":"Brand","carNumber":"Govt. number","carModel":"Model","dateProduction":"Release year"}}')
  delete Component.options._Ctor
}
